import React from "react"
import PropTypes from "prop-types"
import ArrowRightThinIcon from "./ArrowRightThinIcon"

const ArrowLeftThinIcon = ({ style }) => (
  <div
    style={{
      transform: 'rotate(-180deg)'
    }}
  >
    <ArrowRightThinIcon style={style} />
  </div>
)

ArrowLeftThinIcon.propTypes = {
  style: PropTypes.object
}

export default ArrowLeftThinIcon



// WEBPACK FOOTER //
// ./src/AtomicComponents/Icons/ArrowLeftThinIcon.jsx